import i18n from '@/i18n/index'
import { saveToCache } from '@/helpers/localStorage.js'
import { setLocale } from '@vee-validate/i18n'

export const changeLocale = (newLocale) => {
	if (!i18n.global.availableLocales.includes(newLocale)) return

	i18n.global.locale = newLocale
	setLocale(newLocale)

	saveToCache('lang', newLocale)
	document.documentElement.lang = newLocale
}
